import { render, staticRenderFns } from "./AttendancePhotoCard.vue?vue&type=template&id=893b5028&scoped=true&"
import script from "./AttendancePhotoCard.vue?vue&type=script&lang=js&"
export * from "./AttendancePhotoCard.vue?vue&type=script&lang=js&"
import style0 from "./AttendancePhotoCard.vue?vue&type=style&index=0&id=893b5028&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "893b5028",
  null
  
)

export default component.exports